import { render, staticRenderFns } from "./baseRegister.vue?vue&type=template&id=90657054&scoped=true"
import script from "./baseRegister.vue?vue&type=script&lang=js"
export * from "./baseRegister.vue?vue&type=script&lang=js"
import style0 from "./baseRegister.vue?vue&type=style&index=0&id=90657054&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90657054",
  null
  
)

export default component.exports